
const styles = {
  hover: { 'fill-color': 'white', 'fill-opacity': 0.3 },
  ocean: { 'background-color': '#FAFAFA' },
  zonesNonClickable: { 'fill-color': '#7A878D',  },
  zonesNonClickableLine: {'line-width': 0.5, 'line-color': 'white'},
  zonesClickable: { 'fill-color': '#515CA2' },
  zonesClickableLine: { 'line-width': 0.5, 'line-color': 'black' },
  zonesClickableLabel: {
    layout: {
      'text-field': ['get', 'id'],
      'text-variable-anchor': ['top', 'bottom', 'left', 'right'],
      'text-radial-offset': 0.5,
      'text-justify': 'auto',
      'text-size': 10,
      
    },
    paint:  {
      "text-halo-color": "hsl(185, 1%, 100%)",
      "text-halo-width": 1,
"text-halo-blur": 1
    }
  }
}

export default styles